import { createTheme, responsiveFontSizes } from '@mui/material/styles';

const fontFamily = [
  'Noto Sans',
  'OpenSans',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"'
].join(',');

// A custom theme for this app
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    primary: {
      main: '#5182bb'
    },
    secondary: {
      main: '#7ec141'
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    },
    fontFamily
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          backgroundColor: '#f4f4f4'
        },
        body: {
          backgroundColor: '#f4f4f4'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#5182bb !important'
        },
        asterisk: {
          order: '-1',
          color: 'rgba(229, 77, 57, 1)',
          paddingRight: '0.1rem'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          order: '-1',
          color: 'rgba(229, 77, 57, 1)',
          marginRight: '2px'
        }
      }
    }
  }
});
const exportedTheme = responsiveFontSizes(theme);

export default exportedTheme;
